import { StyleRulesCallback } from "@material-ui/core";
import Colors from "../../assets/Colors";

export type StyleType = |"root" | "appBar" | "flex" | "toolBar" | "menuButton" | "logo" | "logoText" | "profileAndLocationContainer" | "signOut";

export const styles: StyleRulesCallback = theme => ({
  root: {
    color: Colors.colWhite,
    width: "100%"
  },
  appBar: {
    color: Colors.colBlack,
    backgroundColor: Colors.colWhite,
    boxShadow: "none"
  },
  toolBar: {
    paddingLeft: 0,
    background: Colors.colHeaderBlue,
    minHeight: "54px!important"
  },
  flex: {
    flex: 1
  },
  menuButton: {},
  logo: {
    width: "6em",
    height: "3em",
    marginLeft: "1em",
  },
  logoText: {
    position: "relative",
    fontSize: 14,
    top: 2.5,
    marginLeft: 8,
    color: theme.palette.grey["400"]
  },
  profileAndLocationContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  signOut: {
    color: "white",
    textDecoration: "underline",
    cursor: "pointer"
  }
});



// WEBPACK FOOTER //
// ./src/components/Header/styles.ts